import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
    children: React.ReactNode;
}

const OnboardingWizardStickyFooterPortal: React.FC<PortalProps> = ({ children }) => {
    /** TODO: find better solution to avoid use in getElementById and use React's useRef */
    const [portalRoot, setPortalRoot] = useState(document.getElementById("onboarding-wizard-sticky-footer")); 

    useEffect(() => {
        if (!portalRoot) {
            setPortalRoot(document.getElementById("onboarding-wizard-sticky-footer"));
        }
    }, [portalRoot])

    if (!portalRoot) return null; // Safety check

    return ReactDOM.createPortal(children, portalRoot); // Inject content
};

export default OnboardingWizardStickyFooterPortal;